module.exports = __webpack_public_path__ + "img/To-Do-app.675e88dd.jpg";